// --------------------------------------------------------------
// Created On: 2021-09-01
// Author: Zachary Thomas
//
// Last Modified: 2026-07-29
// Modified By: Jonathon Hicke
//
// Copyright 2025 - 2026 © Cornell Pump Company, All Rights Reserved
// --------------------------------------------------------------

import React from "react";

// Button for remotely changing speed (RPM or Hertz).
export default function SpeedChangeButton(props: Props): Component {
  const hertz = props.rpmValue;
  return (
    <button
      data-test="speed-change-button"
      className="btn btn-primary w-100"
      type="button"
      disabled={props.disabled}
      onClick={() => props.onClick(props.rpmValue)}
    >
      {props.showHertz ? (
        <span>{hertz} hertz</span>
      ) : (
        <span>
          {props.rpmValue < 1000 ? <span>&nbsp;</span> : ""}
          {props.rpmValue} RPM
        </span>
      )}
    </button>
  );
}

interface Props {
  rpmValue: number;
  showHertz: boolean;
  disabled?: boolean;
  onClick: (rpm: number) => void;
}
